import { css } from 'emotion'

export const SingleTaskWatcherStyles = css``
